import logoSvg from '@/assets/logo.svg'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  variant?: 'image' | 'text'
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
  xl: 'h-20 w-20',
}

const textSizeClasses = {
  sm: 'text-xl',
  md: 'text-2xl',
  lg: 'text-3xl',
  xl: 'text-4xl',
}

export function Logo({ size = 'lg', className = '', variant = 'image' }: LogoProps) {
  if (variant === 'text') {
    const sizeClass = textSizeClasses[size]
    return (
      <h1 className={`font-bold ${sizeClass} ${className}`}>
        <span style={{ color: '#237CCA' }}>Eq</span>
        <span style={{ color: '#10B981' }}>una</span>
      </h1>
    )
  }

  const sizeClass = sizeClasses[size]
  return (
    <img
      src={logoSvg}
      alt="Equna Logo"
      className={`${sizeClass} ${className}`}
    />
  )
}
